import { useState } from "react";
import Layout from "@/components/Layout";
import { API_BASE } from "@/lib/api";
import { FileSpreadsheet, FileText, Calendar, TrendingUp } from "lucide-react";

export default function ClienteReportes() {
  const [fro, setFro] = useState("");
  const [to, setTo] = useState("");

  const download = (format) => {
    const token = localStorage.getItem("voycargo_token");
    const q = new URLSearchParams({ format });
    if (fro) q.set("fro", fro);
    if (to) q.set("to", to);
    fetch(`${API_BASE}/reports/autoservicio/me?${q.toString()}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob())
      .then((b) => {
        const url = URL.createObjectURL(b);
        const a = document.createElement("a");
        a.href = url;
        a.download = `voycargo-mis-envios.${format === "excel" ? "xlsx" : "pdf"}`;
        a.click();
      });
  };

  return (
    <Layout>
      <div className="mb-8">
        <div className="font-mono-tech text-xs text-yellow-300 uppercase tracking-widest mb-2">/ Autoservicio</div>
        <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter">Reporte de mis envíos</h1>
        <p className="text-zinc-400 mt-3 max-w-2xl">Descarga en Excel o PDF el detalle completo de todos tus pedidos con sus estados, fechas y direcciones.</p>
      </div>

      <div className="max-w-2xl border border-white/10 bg-zinc-900/40 p-8">
        <div className="flex items-center gap-3 mb-6">
          <TrendingUp className="w-6 h-6 text-yellow-300" />
          <div className="font-display font-bold text-xl">Selecciona el rango</div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-8">
          <div>
            <label className="block text-[10px] font-mono-tech uppercase tracking-widest text-zinc-500 mb-2">Desde</label>
            <input type="date" value={fro} onChange={(e) => setFro(e.target.value)} className="w-full bg-transparent border border-white/20 focus:border-yellow-300 outline-none px-3 py-2 text-sm font-mono-tech" data-testid="date-from" />
          </div>
          <div>
            <label className="block text-[10px] font-mono-tech uppercase tracking-widest text-zinc-500 mb-2">Hasta</label>
            <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="w-full bg-transparent border border-white/20 focus:border-yellow-300 outline-none px-3 py-2 text-sm font-mono-tech" data-testid="date-to" />
          </div>
        </div>

        <div className="text-xs text-zinc-500 font-mono-tech uppercase tracking-widest mb-3">
          Si dejas los campos vacíos, se descarga el histórico completo
        </div>

        <div className="grid grid-cols-2 gap-3">
          <button onClick={() => download("excel")} data-testid="download-excel" className="bg-yellow-300 text-black font-bold py-3 uppercase tracking-widest text-sm hover:bg-yellow-200 inline-flex items-center justify-center gap-2">
            <FileSpreadsheet className="w-4 h-4" /> Descargar Excel
          </button>
          <button onClick={() => download("pdf")} data-testid="download-pdf" className="border border-white/20 hover:border-yellow-300 font-bold py-3 uppercase tracking-widest text-sm inline-flex items-center justify-center gap-2">
            <FileText className="w-4 h-4" /> Descargar PDF
          </button>
        </div>
      </div>
    </Layout>
  );
}
